import {
  EnhancedStore,
  configureStore as reduxToolkitConfigureStore,
} from '@reduxjs/toolkit';
import { DEPLOY_ENV } from 'config';
import createSagaMiddleware from 'redux-saga';
import { api } from 'services/api/api.rtk';
import { createScopedErrorHandler } from 'utils/functions/handleError';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import { AppState } from './types';

export default function configureStore(initialState?: AppState) {
  const sagaMiddleware = createSagaMiddleware({
    onError: createScopedErrorHandler('saga'),
  });

  // https://redux-toolkit.js.org/api/configurestore/
  const store = reduxToolkitConfigureStore({
    reducer: rootReducer,
    middleware(getDefaultMiddleware) {
      return getDefaultMiddleware({ serializableCheck: false }).concat(
        sagaMiddleware as any,
        api.middleware,
      );
    },
    devTools: !import.meta.env.PROD || DEPLOY_ENV === 'development',
    preloadedState: initialState,
  });

  // Kickstarts the sagas.
  sagaMiddleware.run(rootSaga);

  return store as EnhancedStore<AppState>;
}
